// eslint-disable-next-line
import { UserLayout, BlankLayout } from "@/layouts/index.js";
// Teams removed
// EditProjectRequirement removed
// Requirements removed
import { PERMISSIONS } from "@/constants/permissions.js";

export const asyncRouterMap = [
  {
    path: "/",
    component: BlankLayout,
    meta: {
      title: "menu.home",
      showInNav: true
    },
    redirect: "/dashboard",
    children: [
      // dashboard
      {
        path: "",
        name: "home",
        component: () => import("@/views/dashboard/index.vue"),
        meta: {
          title: "menu.home",
          keepAlive: true
        }
      },
      {
        path: "/candidates",
        component: UserLayout,
        meta: {
          title: "menu.candidates",
          showInNav: true,
          keepAlive: true
        },
        children: [
          {
            path: "",
            name: "candidates",
            component: () => import("@/views/candidates/index.vue"),
            meta: {
              title: "menu.candidates"
            }
          },
          {
            path: "new",
            name: "candidatesNew",
            component: () => import("@/views/candidates/edit.vue"),
            meta: { title: "menu.candidates.new" }
          },
          {
            path: ":id",
            component: UserLayout,
            meta: { title: "menu.candidates" },
            children: [
              {
                path: "",
                name: "candidate",
                component: () => import("@/views/candidates/candidate.vue"),
                meta: { title: "menu.candidates" }
              },
              {
                path: "edit",
                name: "candidatesEdit",
                component: () => import("@/views/candidates/edit.vue"),
                meta: { title: "menu.candidates.edit" }
              },
              {
                path: "payment_infos",
                component: UserLayout,
                meta: { title: "menu.candidates.payment_infos" },
                children: [
                  {
                    path: "",
                    name: "paymentInfos",
                    component: () => import("@/views/candidates/payment.vue"),
                    meta: { title: "menu.candidates.payment_infos" }
                  },
                  {
                    path: ":payment_id/edit",
                    name: "paymentEdit",
                    component: () => import("@/views/candidates/editPayment.vue"),
                    meta: { title: "menu.candidates.payment_edit" }
                  }
                ]
              },
              {
                path: "new_payment_info",
                name: "paymentNew",
                component: () => import("@/views/candidates/editPayment.vue"),
                meta: { title: "menu.candidates.payment_new" }
              }
            ]
          }
          // {
          //   path: '/abroad',
          //   component: UserLayout,
          //   meta: {
          //     title: 'menu.candidates.abroad',
          //     icon: 'file-markdown',
          //,
          //   },
          //   children: [
          //     {
          //       path: '',
          //       name: 'abroad',
          //       component: Abroad,
          //     }
          //   ],
          // }
        ]
      },
      {
        path: "/galaxy",
        component: UserLayout,
        meta: {
          title: "menu.galaxy",
          showInNav: true,
          keepAlive: true
        },
        children: [
          {
            path: "",
            name: "galaxy",
            component: () => import("@/views/galaxy/index.vue"),
            meta: { title: "menu.galaxy" }
          }
        ]
      },
      {
        path: "/companies",
        component: UserLayout,
        meta: {
          title: "menu.companies",
          showInNav: true,
          keepAlive: true
        },
        children: [
          {
            path: "",
            name: "companies",
            meta: { title: "menu.companies" },
            component: () => import("@/views/companies/index.vue")
          },
          {
            path: "new",
            name: "companiesNew",
            meta: { title: "menu.companies.new" },
            component: () => import("@/views/companies/edit.vue")
          },
          {
            path: ":id",
            component: UserLayout,
            meta: { title: "menu.companies" },
            children: [
              {
                path: "",
                name: "companiesDetail",
                meta: { title: "menu.companies" },
                component: () => import("@/views/companies/detail.vue")
              },
              {
                path: "edit",
                name: "companiesEdit",
                meta: { title: "menu.companies.edit" },
                component: () => import("@/views/companies/edit.vue")
              },
              {
                path: "new_contract",
                name: "newContract",
                meta: { title: "menu.companies.contract_new" },
                component: () => import("@/views/companies/contract.vue")
              },
              {
                path: "new_client",
                meta: { title: "menu.companies.client_new" },
                component: () => import("@/views/companies/client.vue")
              },
              {
                path: "candidates/:client_id/edit_client",
                name: "editClient",
                meta: { title: "menu.companies.client_edit" },
                component: () => import("@/views/companies/client.vue")
              },
              {
                path: "contracts/:contract_id/edit",
                name: "editContract",
                meta: { title: "menu.companies.contract_edit" },
                component: () => import("@/views/companies/contract.vue")
              }
            ]
          }
        ]
      },
      {
        path: "/client_seat",
        component: UserLayout,
        meta: { title: "menu.client_seat" },
        children: [
          {
            path: "",
            name: "ClientSeat",
            component: () => import("@/views/clientSeat/index.vue"),
            meta: { title: "menu.client_seat" }
          },
          {
            path: "new",
            component: () => import("@/views/clientSeat/edit.vue"),
            meta: { title: "menu.client_seat.new" }
          },
          {
            path: ":id/edit",
            name: "editSeat",
            component: () => import("@/views/clientSeat/edit.vue"),
            meta: { title: "menu.client_seat.edit" }
          }
        ]
      },
      {
        path: "/tasks",
        name: "tasks",
        component: () => import("@/views/tasks/index.vue"),
        meta: {
          title: "menu.tasks",
          showInNav: true,
          keepAlive: true
        }
      },
      {
        path: "/meetings",
        component: UserLayout,
        meta: {
          title: "menu.meetings",
          showInNav: true,
          keepAlive: true
        },
        children: [
          {
            path: "",
            name: "meetings",
            component: () => import("@/views/meetings/index.vue"),
            meta: { title: "menu.meetings", keepAlive: true }
          },
          {
            path: "new",
            name: "meetingNew",
            component: () => import("@/views/meetings/form.vue"),
            meta: { title: "menu.meetings.new" }
          },
          {
            path: ":id",
            component: UserLayout,
            meta: { title: "menu.meetings.detail" },
            children: [
              {
                path: "",
                name: "meetingDetail",
                component: () => import("@/views/meetings/detail.vue"),
                meta: { title: "menu.meetings.detail" }
              },
              {
                path: "edit",
                name: "meetingEdit",
                component: () => import("@/views/meetings/form.vue"),
                meta: { title: "menu.meetings.edit" }
              }
            ]
          }
        ]
      },
      {
        path: "/topics",
        component: UserLayout,
        meta: {
          title: "menu.topics",
          showInNav: true,
          keepAlive: true
        },
        children: [
          {
            path: "",
            name: "topics",
            component: () => import("@/views/topics/index.vue"),
            meta: { title: "menu.topics", keepAlive: true }
          },
          {
            path: "new",
            name: "topicNew",
            component: () => import("@/views/topics/form.vue"),
            meta: { title: "menu.topics.new" }
          },
          {
            path: ":id",
            component: UserLayout,
            meta: { title: "menu.topics.detail" },
            children: [
              {
                path: "",
                name: "topicDetail",
                component: () => import("@/views/topics/detail.vue"),
                meta: { title: "menu.topics.detail" }
              },
              {
                path: "edit",
                name: "topicEdit",
                component: () => import("@/views/topics/form.vue"),
                meta: { title: "menu.topics.edit" }
              }
            ]
          }
        ]
      },
      {
        path: "/projects",
        component: UserLayout,
        meta: {
          title: "menu.projects",
          showInNav: true,
          keepAlive: true
        },
        children: [
          {
            path: "",
            name: "projects",
            component: () => import("@/views/projects/index.vue"),
            meta: {
              title: "menu.projects",
              showInNav: true,
              keepAlive: true
            }
          },
          {
            path: "new",
            name: "projectNew",
            component: () => import("@/views/project/edit.vue"),
            meta: { title: "menu.projects", keepAlive: true }
          },
          {
            path: ":id",
            component: UserLayout,
            meta: { title: "menu.projects", keepAlive: true },
            children: [
              {
                path: "",
                name: "project",
                component: () => import("@/views/project/index.vue"),
                meta: { title: "menu.projects", keepAlive: true }
              },
              {
                path: "edit",
                name: "projectEdit",
                component: () => import("@/views/project/edit.vue"),
                meta: { title: "menu.projects" }
              },
              {
                path: "add_clients",
                name: "addClients",
                component: () => import("@/views/clients/addClients.vue"),
                meta: { title: "menu.projects.add_clients", keepAlive: true }
              },
              {
                path: "add_project_task",
                name: "addProjectTask",
                component: () => import("@/views/project/addProjectTask.vue"),
                meta: { title: "menu.projects.add_project_task", keepAlive: true }
              }
            ]
          }
        ]
      },
      {
        path: "project_tasks",
        component: UserLayout,
        meta: { title: "menu.project_tasks" },
        children: [
          {
            path: ":task_id",
            component: UserLayout,
            meta: { title: "menu.project_tasks.detail" },
            children: [
              {
                path: "",
                name: "projectTaskDetail",
                component: () => import("@/views/project/projectTaskDetail.vue"),
                meta: { title: "menu.project_tasks.detail" }
              },
              {
                path: "edit",
                name: "projectTaskEdit",
                component: () => import("@/views/project/projectTaskEdit.vue"),
                meta: { title: "menu.project_tasks.edit" }
              }
            ]
          }
        ]
      },
      {
        path: "/finance",
        component: UserLayout,
        meta: {
          title: "menu.finance",
          showInNav: true,
          showChildren: true,
          keepAlive: true
        },
        children: [
          {
            path: "/finance_payment",
            component: UserLayout,
            meta: {
              title: "menu.finance.finance_payment",
              icon: "account-book"
            },
            children: [
              {
                path: "",
                name: "FinancePayment",
                component: () => import("@/views/finance_payment/index.vue"),
                meta: { title: "menu.finance.finance_payment" }
              },
              {
                path: ":id",
                component: UserLayout,
                meta: { title: "menu.finance.finance_payment" },
                children: [
                  {
                    path: "",
                    meta: { title: "menu.finance.finance_payment" },
                    component: () => import("@/views/finance_payment/detail.vue")
                  },
                  {
                    path: "edit",
                    meta: { title: "menu.finance.finance_payment" },
                    component: () => import("@/views/finance_payment/edit.vue")
                  }
                ]
              }
            ]
          },
          {
            path: "/finance_collection",
            component: UserLayout,
            meta: {
              title: "menu.finance.finance_collection",
              icon: "money-collect"
            },
            children: [
              {
                path: "",
                name: "FinanceCollection",
                component: () => import("@/views/finance_collection/index.vue"),
                meta: { title: "menu.finance.finance_collection" }
              },
              {
                path: ":id",
                component: UserLayout,
                meta: { title: "menu.finance.finance_collection" },
                children: [
                  {
                    path: "",
                    meta: { title: "menu.finance.finance_collection" },
                    component: () => import("@/views/finance_payment/detail.vue")
                  },
                  {
                    path: "edit",
                    meta: { title: "menu.finance.finance_collection" },
                    component: () => import("@/views/finance_payment/edit.vue")
                  }
                ]
              }
            ]
          },
          {
            path: "/finance_invoices",
            component: UserLayout,
            meta: {
              title: "menu.finance.finance_invoices",
              icon: "file-text"
            },
            children: [
              {
                path: "",
                name: "FinanceInvoices",
                component: () => import("@/views/finance_invoices/index.vue"),
                meta: { title: "menu.finance.finance_invoices" }
              },
              {
                path: "new",
                name: "FinanceInvoiceCreate",
                component: () => import("@/views/finance_invoices/edit.vue"),
                meta: { title: "menu.finance.finance_invoices" }
              },
              {
                path: ":id",
                component: UserLayout,
                meta: { title: "menu.finance.finance_invoices" },
                children: [
                  {
                    path: "",
                    name: "FinanceInvoiceDetail",
                    component: () => import("@/views/finance_invoices/detail.vue"),
                    meta: { title: "menu.finance.finance_invoices" }
                  }
                ]
              }
            ]
          },
          {
            path: "/finance_customer_payments",
            component: UserLayout,
            meta: {
              title: "menu.finance.finance_customer_payments",
              icon: "bank"
            },
            children: [
              {
                path: "",
                name: "FinanceCustomerPayments",
                component: () => import("@/views/finance_customer_payments/index.vue"),
                meta: { title: "menu.finance.finance_customer_payments" }
              },
              {
                path: "new",
                name: "FinanceCustomerPaymentNew",
                component: () => import("@/views/finance_customer_payments/edit.vue"),
                meta: { title: "menu.finance.finance_customer_payments" }
              },
              {
                path: ":id",
                component: UserLayout,
                meta: { title: "menu.finance.finance_customer_payments" },
                children: [
                  {
                    path: "",
                    name: "FinanceCustomerPaymentDetail",
                    component: () => import("@/views/finance_customer_payments/detail.vue"),
                    meta: { title: "menu.finance.finance_customer_payments" }
                  },
                  {
                    path: "edit",
                    name: "FinanceCustomerPaymentEdit",
                    component: () => import("@/views/finance_customer_payments/edit.vue"),
                    meta: { title: "menu.finance.finance_customer_payments" }
                  }
                ]
              }
            ]
          },
          {
            path: "/finance_uncharged",
            component: UserLayout,
            meta: {
              title: "menu.finance.finance_uncharged",
              icon: "compass"
            },
            children: [
              {
                path: "",
                name: "FinanceUncharged",
                component: () => import("@/views/finance_uncharged/index.vue"),
                meta: { title: "menu.finance.finance_uncharged" }
              }
            ]
          },
          {
            path: "/finance_incentives",
            component: UserLayout,
            meta: {
              title: "menu.finance.finance_incentives",
              icon: "dollar"
            },
            children: [
              {
                path: "",
                name: "FinanceIncentives",
                component: () => import("@/views/finance_incentives/index.vue"),
                meta: { title: "menu.finance.finance_incentives" }
              }
            ]
          }
        ]
      },
      {
        path: "/users/sign_in",
        name: "signIn",
        component: () => import("@/views/users/login.vue"),
        meta: { hideNav: true }
      },
      {
        path: "/users",
        component: UserLayout,
        meta: {
          title: "menu.users",
          showInNav: true,
          keepAlive: true
        },
        children: [
          {
            path: "",
            name: "users",
            component: () => import("@/views/users/index.vue"),
            meta: { title: "menu.users" }
          },
          {
            path: "new",
            name: "addUser",
            component: () => import("@/views/users/new.vue"),
            meta: { title: "menu.users.new" }
          },
          {
            path: "my_account",
            name: "myAccount",
            component: () => import("@/views/myAccount/index.vue"),
            meta: { title: "menu.settings.account" }
          },
          {
            path: "edit_my_password",
            name: "editMyPaasword",
            component: () => import("@/views/myAccount/editMyPassword.vue"),
            meta: { title: "menu.users.edit_my_password" }
          },
          {
            path: "edit_my_account",
            name: "editMyAccount",
            component: () => import("@/views/myAccount/editMyAccount.vue"),
            meta: { title: "menu.users.edit_my_account" }
          },
          {
            path: ":id",
            component: UserLayout,
            meta: { title: "menu.users" },
            children: [
              {
                path: "",
                name: "userDetail",
                component: () => import("@/views/users/detail.vue"),
                meta: { title: "menu.users" }
              },
              {
                path: "edit",
                name: "editUser",
                component: () => import("@/views/users/edit.vue"),
                meta: { title: "menu.users.edit" }
              },
              {
                path: "edit_password",
                name: "editPassword",
                component: () => import("@/views/users/editPassword.vue"),
                meta: { title: "menu.users.reset_password" }
              }
            ]
          }
        ]
      },
      {
        path: "/settings",
        name: "settings",
        component: UserLayout,
        meta: {
          title: "menu.settings",
          showInNav: true,
          showChildren: true,
          keepAlive: true
        },
        children: [
          {
            path: "/settings/expert-blacklist",
            name: "expertBlacklist",
            component: () => import("@/views/expertBlacklist/index.vue"),
            meta: {
              title: "menu.settings.expert_blacklist",
              icon: "safety-certificate",
              requiredActionPermission: PERMISSIONS.CANDIDATE_BLACKLIST_MANAGE
            }
          },
          {
            path: "/card_templates",
            component: UserLayout,
            meta: {
              title: "menu.settings.card_templates",
              // icon: 'drivers-license-o',
              icon: "file-markdown"
            },
            children: [
              {
                path: "",
                name: "cardTemplates",
                component: () => import("@/views/cardTemplates/index.vue"),
                meta: { title: "menu.settings.card_templates" }
              },
              {
                path: "new",
                name: "newCardTemplate",
                component: () => import("@/views/cardTemplates/detail.vue"),
                meta: { title: "menu.settings.card_templates_new" }
              },
              {
                path: ":id/edit",
                name: "editCardTemplate",
                component: () => import("@/views/cardTemplates/detail.vue"),
                meta: { title: "menu.settings.card_templates_edit" }
              }
            ]
          },
          {
            path: "/location_data",
            name: "locationData",
            component: () => import("@/views/locationData/index.vue"),
            meta: {
              title: "menu.settings.location_data",
              // icon: 'location-arrow',
              icon: "environment",
              keepAlive: true
            }
          },
          {
            path: "/banks",
            component: UserLayout,
            meta: {
              title: "menu.settings.banks",
              // icon: 'bank',
              icon: "credit-card"
            },
            children: [
              {
                path: "",
                name: "banks",
                component: () => import("@/views/banks/index.vue"),
                meta: { title: "menu.settings.banks" }
              },
              {
                path: "new",
                name: "newBank",
                component: () => import("@/views/banks/detail.vue"),
                meta: { title: "menu.settings.banks_new" }
              },
              {
                path: ":id/edit",
                name: "editBank",
                component: () => import("@/views/banks/detail.vue"),
                meta: { title: "menu.settings.banks_edit" }
              }
            ]
          },
          {
            path: "/payment_companies",
            component: UserLayout,
            meta: {
              title: "menu.settings.payment_companies",
              icon: "credit-card"
            },
            children: [
              {
                path: "",
                name: "paymentCompanies",
                component: () => import("@/views/paymentCompanies/index.vue"),
                meta: { title: "menu.settings.payment_companies" }
              },
              {
                path: "new",
                name: "newPaymentCompany",
                component: () => import("@/views/paymentCompanies/detail.vue"),
                meta: { title: "menu.settings.payment_companies_new" }
              },
              {
                path: ":id/edit",
                name: "editPaymentCompany",
                component: () => import("@/views/paymentCompanies/detail.vue"),
                meta: { title: "menu.settings.payment_companies_edit" }
              }
            ]
          },
          {
            path: "/translation_vendors",
            component: UserLayout,
            meta: {
              title: "menu.settings.translation_vendors",
              icon: "translation"
            },
            children: [
              {
                path: "",
                name: "translationVendors",
                component: () => import("@/views/translationVendors/index.vue"),
                meta: { title: "menu.settings.translation_vendors" }
              },
              {
                path: "new",
                name: "newTranslationVendor",
                component: () => import("@/views/translationVendors/detail.vue"),
                meta: { title: "menu.settings.translation_vendors_new" }
              },
              {
                path: ":id/edit",
                name: "editTranslationVendor",
                component: () => import("@/views/translationVendors/detail.vue"),
                meta: { title: "menu.settings.translation_vendors_edit" }
              }
            ]
          },
          {
            path: "/roles",
            name: "roles",
            component: () => import("@/views/roles/index.vue"),
            meta: {
              title: "menu.settings.roles",
              icon: "team"
            }
          },
          {
            path: "/permissions",
            name: "permissions",
            component: () => import("@/views/permissions/index.vue"),
            meta: {
              title: "menu.settings.permissions",
              icon: "safety-certificate"
            }
          },
          {
            path: "/applications",
            name: "applications",
            component: () => import("@/views/applications/index.vue"),
            meta: {
              title: "menu.settings.applications",
              icon: "key"
            }
          },
          {
            path: "/meeting-recordings",
            name: "meetingRecordings",
            component: () => import("@/views/admin/meetingRecordings.vue"),
            meta: {
              title: "menu.settings.meeting_recordings",
              icon: "video-camera",
              keepAlive: true
            }
          },
          {
            path: "/project_code_areas",
            component: UserLayout,
            meta: {
              title: "menu.settings.project_code_areas",
              // icon: 'map-marker',
              // icon: 'compass',
              icon: "pushpin"
            },
            children: [
              {
                path: "",
                name: "codeAreas",
                component: () => import("@/views/codeAreas/index.vue"),
                meta: { title: "menu.settings.project_code_areas" }
              },
              {
                path: "new",
                name: "newCodeArea",
                component: () => import("@/views/codeAreas/detail.vue"),
                meta: { title: "menu.settings.project_code_areas_new" }
              },
              {
                path: ":id/edit",
                name: "editCodeArea",
                component: () => import("@/views/codeAreas/detail.vue"),
                meta: { title: "menu.settings.project_code_areas_edit" }
              }
            ]
          },
          {
            path: "/industries",
            component: UserLayout,
            meta: {
              title: "menu.settings.industry",
              // icon: 'industry',
              icon: "project",
              keepAlive: true
            },
            children: [
              {
                path: "",
                name: "industries",
                component: () => import("@/views/industries/index.vue"),
                meta: { title: "menu.settings.industry" }
              },
              {
                path: "new",
                name: "newIndustry",
                component: () => import("@/views/industries/detail.vue"),
                meta: { title: "menu.settings.industry_new" }
              },
              {
                path: ":id/edit",
                name: "editIndustry",
                component: () => import("@/views/industries/detail.vue"),
                meta: { title: "menu.settings.industry_edit" }
              }
            ]
          },
          {
            path: "/exchange_rates",
            name: "exchangeRates",
            component: () => import("@/views/exchangeRates/index.vue"),
            meta: {
              title: "menu.settings.exchange_rates",
              icon: "swap",
              keepAlive: true
            }
          },
          {
            path: "/users/my_account",
            meta: {
              title: "menu.settings.account",
              icon: "home",
              keepAlive: true
            }
          }
        ]
      },
      {
        path: "/notices",
        component: UserLayout,
        meta: {
          title: "menu.notices",
          keepAlive: true
        },
        children: [
          {
            path: "",
            name: "notice",
            component: () => import("@/views/notice/index.vue"),
            meta: { title: "menu.notices" }
          },
          {
            path: "new",
            name: "newNotice",
            component: () => import("@/views/notice/detail.vue"),
            meta: { title: "menu.notices.new" }
          },
          {
            path: ":id/edit",
            name: "editNotice",
            component: () => import("@/views/notice/detail.vue"),
            meta: { title: "menu.notices.edit" }
          }
        ]
      },
      {
        path: "/ranking",
        name: "ranking",
        component: () => import("@/views/ranking/index.vue"),
        meta: {
          title: "menu.ranking",
          keepAlive: true
        }
      },
      {
        path: "/call_ranking",
        name: "callRanking",
        component: () => import("@/views/callRanking/index.vue"),
        meta: { title: "menu.callRanking", keepAlive: true }
      },
      {
        path: "/ongoing_project_tasks",
        name: "ongoingProjectTasks",
        component: () => import("@/views/projects/ongoingProjectTasks.vue"),
        meta: {
          title: "menu.projects.ongoing_project_tasks",
          keepAlive: true
        }
      },
      {
        path: "/failed_project_tasks",
        name: "failedProjectTasks",
        component: () => import("@/views/projects/failedProjectTasks.vue"),
        meta: {
          title: "menu.projects.failed_project_tasks",
          keepAlive: true
        }
      },
      {
        path: "/billing_projects",
        name: "billingProjects",
        component: () => import("@/views/projects/billingProjects.vue"),
        meta: {
          title: "menu.projects.billing_projects",
          keepAlive: true
        }
      },
      {
        path: "/admin",
        name: "admin",
        component: () => import("@/views/admin/index.vue"),
        meta: {
          title: "menu.admin",
          showInNav: true,
          keepAlive: true
        }
      },
      {
        path: "/admin/activities",
        name: "adminActivities",
        component: () => import("@/views/adminActivities/index.vue"),
        meta: {
          title: "menu.admin.activities",
          keepAlive: true
        }
      },
      {
        path: "/admin/expert-recruitment-candidates",
        name: "adminExpertRecruitmentCandidates",
        component: () => import("@/views/admin/expertRecruitmentCandidates.vue"),
        meta: {
          title: "menu.admin.expert_recruitment_candidates",
          keepAlive: true
        }
      }
    ]
  }
];
/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: "/404",
    component: () => import("@/views/exception/404.vue")
  },
  ...asyncRouterMap,
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/exception/404.vue")
  }
];
